import { uniq } from "underscore";
import { updateField } from "vuex-map-fields";

export default {
    async loaded_short(state, data) {
        state.short_products = uniq([...data.products], 'uuid');
    },
    updateField
};
